import { useState } from "react";
import { Calendar } from "lucide-react";

function iso(d) { return d.toISOString().slice(0, 10); }

export function presetRange(key) {
  const now = new Date();
  const end = iso(now);
  const startOf = (dt) => iso(dt);
  if (key === "today") return { start: end, end, label: "Today" };
  if (key === "7d") { const d = new Date(); d.setDate(d.getDate() - 6); return { start: startOf(d), end, label: "Last 7 days" }; }
  if (key === "30d") { const d = new Date(); d.setDate(d.getDate() - 29); return { start: startOf(d), end, label: "Last 30 days" }; }
  if (key === "month") { const d = new Date(now.getFullYear(), now.getMonth(), 1); return { start: startOf(d), end, label: "This month" }; }
  if (key === "fy") {
    const y = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1; // FY starts Apr 1
    return { start: `${y}-04-01`, end, label: `FY ${y}-${String((y + 1) % 100).padStart(2, "0")}` };
  }
  return { start: null, end: null, label: "All time" };
}

const PRESETS = [["all", "All time"], ["today", "Today"], ["7d", "Last 7 days"], ["30d", "Last 30 days"], ["month", "This month"], ["fy", "Financial year"]];

export function DateRangePicker({ value, onChange }) {
  const [custom, setCustom] = useState(false);
  const active = value?.key || "all";

  const pick = (key) => {
    if (key === "custom") { setCustom(true); return; }
    setCustom(false);
    onChange({ key, ...presetRange(key) });
  };
  const setCustomDate = (field, v) => {
    const next = { key: "custom", label: "Custom", start: value?.start || null, end: value?.end || null, [field]: v || null };
    onChange(next);
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="date-range-picker">
      <Calendar className="h-4 w-4 text-zinc-400" />
      <div className="flex items-center gap-0.5 bg-zinc-100 rounded-lg p-0.5">
        {PRESETS.map(([k, l]) => (
          <button key={k} data-testid={`range-${k}`} onClick={() => pick(k)}
            className={`px-2.5 py-1.5 rounded-md text-xs font-bold uppercase tracking-wide transition-colors ${active === k && !custom ? "bg-white text-klein shadow-sm" : "text-zinc-500 hover:text-zinc-900"}`}>
            {l}
          </button>
        ))}
        <button data-testid="range-custom" onClick={() => pick("custom")}
          className={`px-2.5 py-1.5 rounded-md text-xs font-bold uppercase tracking-wide transition-colors ${custom || active === "custom" ? "bg-white text-klein shadow-sm" : "text-zinc-500 hover:text-zinc-900"}`}>
          Custom
        </button>
      </div>
      {(custom || active === "custom") && (
        <div className="flex items-center gap-1.5" data-testid="custom-range">
          <input type="date" data-testid="range-start" value={value?.start || ""} onChange={(e) => setCustomDate("start", e.target.value)}
            className="border border-zinc-300 rounded-lg text-sm px-2 py-1.5 focus:border-klein focus:outline-none" />
          <span className="text-zinc-400 text-xs">to</span>
          <input type="date" data-testid="range-end" value={value?.end || ""} onChange={(e) => setCustomDate("end", e.target.value)}
            className="border border-zinc-300 rounded-lg text-sm px-2 py-1.5 focus:border-klein focus:outline-none" />
        </div>
      )}
    </div>
  );
}
